import { render, staticRenderFns } from "./ForthForm.vue?vue&type=template&id=d5d2ded0&scoped=true&"
import script from "./ForthForm.vue?vue&type=script&lang=js&"
export * from "./ForthForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=d5d2ded0&prod&scoped=true&lang=css&"
import style1 from "./ForthForm.vue?vue&type=style&index=1&id=d5d2ded0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d2ded0",
  null
  
)

export default component.exports